import { render, staticRenderFns } from "./BlockSlide.vue?vue&type=template&id=a00828ce&"
import script from "./BlockSlide.vue?vue&type=script&lang=js&"
export * from "./BlockSlide.vue?vue&type=script&lang=js&"
import style0 from "./BlockSlide.vue?vue&type=style&index=0&id=a00828ce&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports